import { Button } from '@getro/rombo';
import { ExternalLink } from 'lucide-react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Image, Text } from 'rebass/styled-components';

import LockIcon from '../../../assets/icon-lock.svg';
import { openChat } from '../../../helpers/supportChat';
import { userSelector } from '../../../redux/selectors';

export const VerifyEmail = () => {
  const user = useSelector(userSelector);
  const [showContactUs, setShowContactUs] = useState(false);

  return (
    <Flex justifyContent="center" flexDirection="column" alignItems="center">
      <Image width="80px" height="80px" src={LockIcon} alt="Verify email" />
      <Text mt="8px" fontSize="22px" fontWeight="semibold" color="text.dark">
        Verify your email
      </Text>
      <Text
        mt="8px"
        sx={{ textAlign: 'center' }}
      >{`We sent an email to ${user?.email}. Click the link in it to verify your address.`}</Text>
      <Button
        variant="secondary"
        icon={ExternalLink}
        iconPosition="right"
        mt="24px"
        width="155px"
        onClick={() => {
          window.open(`https://mail.google.com/mail/u/0/#inbox?compose=new&to=${user?.email}`, '_blank');
        }}
      >
        Open Gmail
      </Button>
      <Flex flexDirection="column" alignItems="center" mt="56px" sx={{ gap: '8px' }}>
        <Text
          fontSize="14px"
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => setShowContactUs(true)}
        >
          Didn’t receive the email?
        </Text>
        {showContactUs && (
          <Text fontSize="14px">
            Please check your spam folder. If it’s not there,{' '}
            <Text
              as="span"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => openChat(null, { name: 'Support' })}
            >
              contact us
            </Text>
            .
          </Text>
        )}
      </Flex>
    </Flex>
  );
};
